export default "dist/images/block-feature-overlap3.7f0911e.png";